import statusConst from '@/consts/status.const.js';
import genericTableService from '@/services/genericConfig/genericTable.utils.js';

const dashboardModule = {
  namespaced: true,
  state: {
    AllMandates: {
      rows: [],
      page: 1,
      nTake: 20,
      pageSize: 20,
      total: 0,
    },
    MyMandates: {
      rows: [],
      page: 1,
      nTake: 20,
      pageSize: 20,
      total: 0,
    },
    MyActiveMandates: {
      rows: [],
      page: 1,
      nTake: 20,
      pageSize: 20,
      total: 0,
    },
    rowMandateId: '',
    status: statusConst.PENDING,
    tableConfig: null,
  },
  actions: {
    setAllMandates({ state, commit }, mandates) {
      commit('setAllMandates', mandates);
    },
    setMyMandates({ state, commit }, mandates) {
      commit('setMyMandates', mandates);
    },
    setMyActiveMandates({ state, commit }, mandates) {
      commit('setMyActiveMandates', mandates);
    },
    setStatus({ commit }, payload) {
      commit('setStatus', payload);
    },
    setMandateRowId({ state, commit }, rowMandateId) {
      commit('setMandateRowId', rowMandateId);
    },

    async fetchGenericTableConfig({ state, commit }) {
      const config = await genericTableService.getGenericTableCall(105);
      commit('setTableConfig', config);
    },
  },

  mutations: {
    setAllMandates(state, mandates) {
      state.AllMandates = mandates;
    },

    setMyMandates(state, mandates) {
      state.MyMandates = mandates;
    },

    setMyActiveMandates(state, mandates) {
      state.MyActiveMandates = mandates;
    },

    setStatus(state, payload) {
      state.status = payload;
    },

    setMandateRowId(state, rowMandateId) {
      state.rowMandateId = rowMandateId;
    },

    setTableConfig(state, config) {
      state.tableConfig = config;
    }
  },

  getters: {
    getAllMandates(state) {
      return state.AllMandates;
    },
    getMyMandates(state) {
      return state.MyMandates;
    },
    getMyActiveMandates(state) {
      return state.MyActiveMandates;
    },
    getStatus(state) {
      return state.status;
    },

    getMandateRowId(state) {
      return state.rowMandateId;
    },

    getTableConfigDefaultOrder(state) {
       const config = state?.tableConfig?.map((config) => {
        if (config.InternalField === 'DueDate') {
          config.sort = 'DESC';
        }
         return config;
      });

      return config;
    }
  },
};
export default dashboardModule;
